import { Link } from "react-router-dom";
import { Bookmark, Heart, Check } from "lucide-react";
import { shortRs } from "@/lib/ideas";

export const BADGES = [
  ["beginner", "Beginner", "bg-[#E8F8F4] text-[#179B80]"],
  ["low_cost", "Low startup cost", "bg-amber-50 text-amber-700"],
  ["weekend", "Weekend friendly", "bg-indigo-50 text-indigo-700"],
  ["high_margin", "High margin", "bg-rose-50 text-rose-700"],
];

export function IdeaBadges({ tags = {}, max = 4, exclude = [] }) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {BADGES.filter(([k]) => tags[k] && !exclude.includes(k)).slice(0, max).map(([k, l, c]) => <span key={k} className={`sb-chip ${c}`}>{l}</span>)}
    </div>
  );
}

export default function IdeaCard({ idea, saved, fav, comparing, onToggle, onCompare }) {
  return (
    <div className="sb-card p-4 flex flex-col hover:-translate-y-0.5 hover:shadow-md transition-[transform,box-shadow] duration-200" data-testid={`idea-card-${idea.number}`}>
      <div className="flex items-start justify-between gap-2">
        <span className="text-[11px] font-semibold text-[#8C9BA5]">#{idea.number} · {idea.category}</span>
        <div className="flex -mr-1.5 -mt-1.5">
          <button onClick={() => onToggle(idea.number, "favorite")} className="h-9 w-9 rounded-full flex items-center justify-center hover:bg-[#F5F0E6]" aria-label="Favorite" data-testid={`idea-fav-btn-${idea.number}`}>
            <Heart className={`h-[18px] w-[18px] ${fav ? "fill-[#E05A47] text-[#E05A47]" : "text-[#8C9BA5]"}`} /></button>
          <button onClick={() => onToggle(idea.number, "saved")} className="h-9 w-9 rounded-full flex items-center justify-center hover:bg-[#F5F0E6]" aria-label="Save" data-testid={`idea-save-btn-${idea.number}`}>
            <Bookmark className={`h-[18px] w-[18px] ${saved ? "fill-[#1DB99A] text-[#1DB99A]" : "text-[#8C9BA5]"}`} /></button>
        </div>
      </div>
      <Link to={`/ideas/${idea.number}`} className="mt-1 block flex-1" data-testid={`idea-open-${idea.number}`}>
        <h3 className="font-display font-bold text-[17px] leading-snug text-[#1E2B3C]">{idea.name}</h3>
        <p className="text-xs text-[#5C6B73] mt-1.5 line-clamp-2">{idea.problem}</p>
      </Link>
      <div className="grid grid-cols-2 gap-2 my-3 text-[11px]">
        <div className="rounded-lg bg-[#FBF8F2] px-2.5 py-2"><div className="text-[#8C9BA5]">Startup</div><div className="font-bold text-sm text-[#1E2B3C]" data-testid={`idea-startup-${idea.number}`}>{shortRs(idea.startup_cost)}</div></div>
        <div className="rounded-lg bg-[#E8F8F4] px-2.5 py-2"><div className="text-[#179B80]">Monthly potential</div><div className="font-bold text-sm text-[#1E2B3C]" data-testid={`idea-monthly-${idea.number}`}>{shortRs(idea.revenue_monthly_text)}</div></div>
      </div>
      <div className="flex flex-wrap gap-1.5 mb-3">
        <span className={`sb-chip ${idea.difficulty === "Beginner" ? "bg-[#E8F8F4] text-[#179B80]" : "bg-[#F5F0E6] text-[#5C6B73]"}`}>{idea.difficulty}</span>
        <span className={`sb-chip ${idea.tags?.high_margin ? "bg-rose-50 text-rose-700" : "bg-[#F5F0E6] text-[#5C6B73]"}`}>{idea.margin} margin</span>
        <IdeaBadges tags={idea.tags} max={2} exclude={["beginner", "high_margin"]} />
      </div>
      <div className="flex items-center gap-2 mt-4">
        <Link to={`/ideas/${idea.number}`} className="sb-btn-navy min-h-[40px] text-xs flex-1" data-testid={`idea-view-btn-${idea.number}`}>View Idea</Link>
        <button onClick={() => onCompare(idea.number)} data-testid={`idea-compare-btn-${idea.number}`}
          className={`shrink-0 min-h-[40px] text-[11px] font-bold rounded-xl px-3 border ${comparing ? "bg-[#1DB99A] text-white border-[#1DB99A]" : "border-[#EADEC9] text-[#5C6B73]"}`}>
          {comparing ? <span className="flex items-center gap-1"><Check className="h-3 w-3" />Compare</span> : "+ Compare"}
        </button>
      </div>
    </div>
  );
}
